import axios, { buildApi } from '@/libs/api.request';
let name = '/common/area'

export const apis = buildApi({
  get: [name + '&list', name + '/:id&detail', '/common/city'],
  post: [name + '&add'],
  put: [name + '/:id&update'],
  del: [name + '/:id&del'],
})